import { render } from "./table-icon.svg?vue&type=template&id=3bcaab03"
import script from "./table-icon.svg?vue&type=script&lang=js"
export * from "./table-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1152/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__